import { Nullable } from "util/extendedTypes";
import {
  defaultExistingLoanDetails,
  ExistingLoanDetails,
  RepaymentOption,
  RepaymentOptionType,
} from "./indicativeRepaymentOptions";
import {
  Menu,
  TreatmentOptionPayloadType,
  TreatmentOptions,
} from "./menuOptions";
import { AboutYou } from "./aboutYou";
import { AboutLoan } from "decoders/selectedTreatmentOptionPaylodDecoder";
import { AboutYourLoan } from "./aboutYourLoan";
import { brand } from "services/envService";
import { AssertionAnswer, AssertionAnswers, AssertionItem } from "./assertions";
import { toISODate } from "util/date";

const BRAND = brand();
export const START_YEAR: string = "2026/01/01";
export const END_YEAR: string = "2031/12/31";

export enum RepaymentHolidaysType {
  CapitalRepaymentHoliday = "CRH",
  CapitalIntersestRepaymentHoliday = "CIRH",
}

export type SelectedTreatmentsDetails = {
  treatmentOptionType: TreatmentOptions;
  selectedRHType?: RepaymentHolidaysType;
  selectedOptionType: Nullable<RepaymentOptionType>;
  repaymentOption: Nullable<RepaymentOption>;
  existingLoanDetails: Nullable<ExistingLoanDetails>;
};

export const defaultSelectedTreatmentsDetails =
  (): SelectedTreatmentsDetails => {
    return {
      treatmentOptionType: Menu.RequestRepaymentHoliday,
      selectedRHType: RepaymentHolidaysType.CapitalRepaymentHoliday,
      selectedOptionType: null,
      repaymentOption: null,
      existingLoanDetails: defaultExistingLoanDetails(),
    };
  };

export type SelectedTreatmentPayloadType = {
  aboutYou: Omit<AboutYou, "confirmEmail">;
  aboutLoan: AboutLoan;
  hardStoppedOnUI: boolean;
  attestationInformation: AssertionItem[];
  treatmentOptionType: TreatmentOptionPayloadType;
  selectedOptionType: RepaymentOptionType;
  existingLoanDetails: ExistingLoanDetails;
  repaymentOptions: RepaymentOption[];
};

export const getFinalRepaymentDate = (finalRepaymentDate: Nullable<Date>) =>
  finalRepaymentDate ? toISODate(finalRepaymentDate) : "";

export const aboutLoanEncoder = (aboutYourLoan: AboutYourLoan): AboutLoan => {
  return {
    accountNumber: aboutYourLoan.accountNumber,
    sortCode: aboutYourLoan.sortCode,
    finalRepaymentDate: getFinalRepaymentDate(aboutYourLoan.finalRepaymentDate),
    CIRHWithTermExtensionCountTaken:
      !!aboutYourLoan.CIRHWithTermExtensionCountTaken
        ? aboutYourLoan.CIRHWithTermExtensionCountTaken
        : 0,
    CRHWithTermExtensionCountTaken:
      !!aboutYourLoan.CRHWithTermExtensionCountTaken
        ? aboutYourLoan.CRHWithTermExtensionCountTaken
        : 0,
    fullTermExtensionTaken: aboutYourLoan.fullTermExtensionTaken,
    remainingBalance: aboutYourLoan.remainingBalance,
    CRHCountTaken: !!aboutYourLoan.CRHTaken ? aboutYourLoan.CRHTaken : 0,
    CIRHCountTaken: !!aboutYourLoan.CIRHTaken ? aboutYourLoan.CIRHTaken : 0,
    brand: BRAND,
  };
};

export const attestationEncoder = (
  answers: AssertionAnswers
): AssertionItem[] =>
  answers.answers
    .filter((a: AssertionAnswer) => a.answer !== null)
    .map((ans: AssertionAnswer) => ({
      attestationKey: ans.type,
      attestationValue: !!ans.answer,
    }));
